import { Controller } from "@hotwired/stimulus"

function normalizeSearch(value) {
  return String(value || "").toLowerCase().trim().replace(/\s+/g, " ")
}

function valuesFor(value) {
  return String(value || "").split(/\s+/).filter(Boolean)
}

function includesValue(value, selected) {
  if (!selected) return true
  return valuesFor(value).includes(selected)
}

function hasAny(value) {
  return valuesFor(value).length > 0
}

export { normalizeSearch }

export default class extends Controller {
  static targets = [
    "search",
    "finish",
    "overrides",
    "duplicates",
    "exclusions",
    "newRows",
    "changedRows",
    "row",
    "visibleCount",
    "totalCount"
  ]

  connect() {
    this.totalCountTarget.textContent = this.rowTargets.length
    this.filter()
  }

  filter() {
    const query = normalizeSearch(this.searchTarget.value)
    const finish = this.finishTarget.value
    let visibleCount = 0

    this.rowTargets.forEach((row) => {
      const visible = this.matchesRow(row, query, finish)
      row.hidden = !visible
      row.classList.toggle("spoiler-scrape-result-row-hidden", !visible)
      if (visible) visibleCount += 1
    })

    this.visibleCountTarget.textContent = visibleCount
  }

  clear() {
    this.searchTarget.value = ""
    this.finishTarget.value = ""
    this.overridesTarget.checked = false
    this.duplicatesTarget.checked = false
    this.exclusionsTarget.checked = false
    this.newRowsTarget.checked = false
    this.changedRowsTarget.checked = false
    this.filter()
  }

  matchesRow(row, query, finish) {
    if (query && !normalizeSearch(row.dataset.searchText).includes(query)) {
      return false
    }

    if (!includesValue(row.dataset.finishes, finish)) {
      return false
    }

    if (this.overridesTarget.checked && row.dataset.hasOverrides !== "true") {
      return false
    }

    if (this.duplicatesTarget.checked && !this.matchesMultiValueFlag(row.dataset.duplicateFinishes, finish)) {
      return false
    }

    if (this.exclusionsTarget.checked && !this.matchesExclusions(row, finish)) {
      return false
    }

    if (this.newRowsTarget.checked && !this.matchesMultiValueFlag(row.dataset.newFinishes, finish)) {
      return false
    }

    if (this.changedRowsTarget.checked && !this.matchesMultiValueFlag(row.dataset.changedFinishes, finish)) {
      return false
    }

    return true
  }

  matchesExclusions(row, finish) {
    if (finish) {
      return includesValue(row.dataset.excludedFinishes, finish)
    }

    return row.dataset.hasExclusions === "true"
  }

  matchesMultiValueFlag(value, finish) {
    if (finish) {
      return includesValue(value, finish)
    }

    return hasAny(value)
  }
}
